module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-25000-36a0b800.png";